// src/components/ButtonGroup.js

import React, { useRef } from 'react';
import './ButtonGroup.css';
import Spinner from '../Common/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const ButtonGroup = ({ loading }) => {
  const { t } = useTranslation();
  const buttonRef = useRef(null);

  const handleSpanClick = () => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  };

  const handleSpanKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleSpanClick();
    }
  };

  return (
    <div className="button-group">
      <button
        type="submit"
        className="save-button"
        disabled={loading}
        aria-label={t('buttonGroup.updateSettingsAriaLabel')}
        ref={buttonRef}
      >
        {loading ? (
          <>
            <Spinner size="20px" color="#fff" /> {t('buttonGroup.updating')}
          </>
        ) : (
          <>
            <FontAwesomeIcon icon={faUpload} />{' '}
            {t('buttonGroup.updateSettings')}
          </>
        )}
      </button>
    </div>
  );
};

export default ButtonGroup;
